import { Button } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { successToastMessage } from "utils/errorToast";
import EditIcon from "@material-ui/icons/EditOutlined";
import { updateComments } from "../../action";
import { useDispatch } from "react-redux";

const UserComment = (props) => {
  const { commentRow } = props;
  const dispatch = useDispatch();
  const [content, setContent] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [previousContent, setPreviousContent] = useState("");
  // Custom toolbar options
  const toolbarOptions = [
    [{ header: [1, 2, false] }], // Header options
    ["bold", "italic", "underline"], // Formatting options
    [{ list: "ordered" }, { list: "bullet" }], // Lists
    [{ align: [] }], // Text alignment
    ["clean"], // Remove formatting
  ];

  const modules = {
    toolbar: toolbarOptions, // Toolbar remains the same
  };

  const handleSave = async () => {
    await dispatch(updateComments(commentRow, content));
    setPreviousContent(content); // Save the current content
    setIsEditing(false);
    props.handleCloseComment()
    props.handleSubmit(false,1)
  };

  const handleCancel = () => {
    setContent(previousContent); // Reset content to the previous state
    setIsEditing(false);
  };
  useEffect(() => {
    console.log("content::", content);
    console.log("commentRow::", commentRow);

    // Set initial content from commentRow.USER_COMMENTS
    if (commentRow && commentRow.USER_COMMENTS) {
      setContent(commentRow.USER_COMMENTS);
      setPreviousContent(commentRow.USER_COMMENTS); // Initialize previousContent
    } else {
      // Clear content if no comments exist
      setContent("");
      setPreviousContent("");
    }

    // Reset editing state when a new row is selected
    setIsEditing(false);
  }, [commentRow]); // Add commentRow as dependency
  return (
    <div>
      <ReactQuill
        theme="snow"
        value={content}
        onChange={setContent}
        modules={modules}
        readOnly={!isEditing} // Disable editing when readOnly is true
        placeholder="Write your comment here..."
      />
      <div
        style={{
          marginTop: "1em",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div>
          {/* <Button
            onClick={() => {
                setPreviousContent(content); // Backup the current content
                setIsEditing(true);
              }}
            aria-controls="checkbox-menu"
            aria-haspopup="true"
            type="submit"
            variant="contained"
            color="primary"
            style={{
              backgroundColor: isEditing ? "#4f2d7f" : "grey",
              color: "white",
              textTransform: "capitalize",
              height:'2em'
            }}
          >
            <EditIcon fontSize="small"/>
            Edit
          </Button> */}
          <Button
            onClick={() => {
              setPreviousContent(content); // Backup the current content
              setIsEditing(true);
            }}
            disabled={isEditing} // Disable when in edit mode
            variant="contained"
            color="primary"
            style={{
              backgroundColor: isEditing ? "grey" : "#4f2d7f",
              color: "white",
              textTransform: "capitalize",
              height: "2em",
            }}
            aria-label="Edit Comment"
          >
            <EditIcon fontSize="small" />
            Edit
          </Button>
        </div>

        <div>
          {/* <Button
            onClick={handleSave}
            aria-controls="checkbox-menu"
            aria-haspopup="true"
            type="submit"
            variant="contained"
            color="primary"
            style={{
              backgroundColor: "#4f2d7f",
              color: "white",
              textTransform: "capitalize",
              marginRight: '1em',
              height:'2em'
            }}
          >
            Save
          </Button>
          <Button
            onClick={handleCancel}
            aria-controls="checkbox-menu"
            aria-haspopup="true"
            type="submit"
            variant="outlined"
            color="primary"
            style={{
            //   backgroundColor: "#4f2d7f",
              color: "#4f2d7f",
              textTransform: "capitalize",
              height:'2em'
            }}
          >
            Cancel
          </Button> */}
          <Button
            onClick={handleSave}
            disabled={!isEditing} // Disable when not in edit mode
            variant="contained"
            color="primary"
            style={{
              backgroundColor: isEditing ? "#4f2d7f" : "grey",
              color: "white",
              textTransform: "capitalize",
              marginRight: "1em",
              height: "2em",
            }}
          >
            Save
          </Button>
          <Button
            onClick={handleCancel}
            disabled={!isEditing} // Disable when not in edit mode
            variant="outlined"
            color="primary"
            style={{
              color: "#4f2d7f",
              textTransform: "capitalize",
              height: "2em",
            }}
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UserComment;
